import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M8.46422 20.4844L16.9492 11.9994L8.46422 3.51438L7.04922 4.92838L14.1212 11.9994L7.04922 19.0704L8.46422 20.4844Z" fill="#C4C4C4"/>
  </svg>
);
